import { content, type Language } from '../config/siteContent'
import { routeFor } from '../config/routes'
import { getPricingItem, siteConfig } from '../config/site'
import { Reveal } from './motion'
import PricingValue from './PricingValue'
import { ButtonLink } from './ui'

export default function PricingPreview({ language }: { language: Language }) {
  const copy = content[language]
  const labels = {
    websites: copy.home.pricingWebsite,
    aiVideo: copy.home.pricingAiVideo,
    audio: copy.home.pricingAudio,
    support: copy.home.pricingHourly,
  }

  return (
    <section className="section pricing-preview" aria-labelledby="pricing-preview-title">
      <Reveal className="shell pricing-preview__card">
        <div className="pricing-preview__intro">
          <p className="eyebrow">{copy.home.pricingEyebrow}</p>
          <h2 id="pricing-preview-title">{copy.home.pricingPreviewTitle}</h2>
          <ButtonLink to={`${routeFor(language, 'services')}#pricing`} variant="outline">{copy.home.pricingLink}</ButtonLink>
        </div>
        <dl className="pricing-preview__rates">
          {siteConfig.pricing.featured.map((reference) => {
            const item = getPricingItem(reference.categoryId, reference.itemId)
            if (!item) return null
            return <div key={reference.id}><dt>{labels[reference.id]}</dt><dd><PricingValue language={language} value={item.price} /></dd></div>
          })}
        </dl>
      </Reveal>
    </section>
  )
}
